export abstract class BaseModel {
	constructor(model?: any) {
		if (model)
			this.populate(model);
	}

	public abstract populate(model: any): void;
}
